<template>
  <div class="bm-records">
    <div class="bm-records__tags">
      <button v-for="tag in tags" :key="tag" :class="{ active: activeTag === tag }" @click="changeTag(tag)">
        {{ tag }}
      </button>
    </div>
    <div class="bm-records__table-wrap">
      <table>
        <thead>
          <tr>
            <th>修改内容</th>
            <th>处理进度</th>
            <th>状态</th>
            <th>成功数</th>
            <th>失败数</th>
            <th>跳过数</th>
            <th>商品总数</th>
            <th>时间</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="record in records" :key="record.id">
            <td>
              <strong>{{ record.typeName }}</strong>
              <small>{{ record.rule }}</small>
            </td>
            <td>
              <div class="bm-records__progress"><i :style="{ width: record.progress + '%' }"></i></div>
              <b>{{ record.progress }}%</b>
            </td>
            <td>
              <span class="bm-records__status" :class="record.statusClass">{{ record.status }}</span>
            </td>
            <td class="success">{{ record.success }}</td>
            <td class="danger">{{ record.fail }}</td>
            <td>{{ record.skip }}</td>
            <td>{{ record.total }}</td>
            <td>
              <small>
                修改 {{ record.modDate }}
                <br />
                恢复 {{ record.restoreDate || '—' }}
              </small>
            </td>
            <td>
              <div class="bm-records__actions">
                <button class="blue" @click="openDetail(record)">查看详情</button>
                <button
                  v-if="record.statusValue === 4 && !record.restoreDate && !isRecordExpired(record)"
                  :disabled="restoringId === record.id"
                  @click="restore(record)">
                  {{ restoringId === record.id ? '恢复中' : '恢复' }}
                </button>
                <!-- <button>导出 ▾</button> -->
                <!-- <button v-if="record.statusValue === 3">重试</button>
                <button v-if="record.statusValue === 1 || record.statusValue === 2" class="red">停止</button> -->
                <!-- <button class="red">删除</button> -->
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <footer>
        <span>共 {{ recordPage.total }} 条 · 共 {{ recordTotalPages }} 页 · {{ recordPage.limit }}条/页</span>
        <span>
          <button class="page-arrow" :disabled="recordPage.page <= 1" @click="load(recordPage.page - 1)">‹</button>
          <button
            v-for="page in visibleRecordPages"
            :key="page"
            class="page-number"
            :class="{ active: recordPage.page === page }"
            @click="load(page)">
            {{ page }}
          </button>
          <button class="page-arrow" :disabled="recordPage.page >= recordTotalPages" @click="load(recordPage.page + 1)">
            ›
          </button>
          <span class="page-jump-label">前往</span>
          <input
            v-model.number="jumpPage"
            class="page-jump"
            type="number"
            min="1"
            :max="recordTotalPages"
            @keyup.enter="jumpRecordPage" />
          <span class="page-jump-label">页</span>
          <select v-model.number="recordPage.limit" @change="changeRecordLimit">
            <option :value="10">10条/页</option>
            <option :value="20">20条/页</option>
            <option :value="50">50条/页</option>
          </select>
        </span>
      </footer>
    </div>
    <div v-if="detail" class="bm-records__mask">
      <div class="bm-records__modal">
        <header>
          <strong>查看详情</strong>
          <button @click="detail = null">×</button>
        </header>
        <nav>
          <button :class="{ active: detailTab === 'success' }" @click="changeDetailTab('success')">
            {{ [4, 5, 11].includes(detail.typeValue) ? '成功SKU' : '成功商品' }}（{{ detail.success }}）
          </button>
          <button :class="{ active: detailTab === 'fail' }" @click="changeDetailTab('fail')">
            {{ [4, 5, 11].includes(detail.typeValue) ? '失败SKU' : '失败商品' }}（{{ detail.fail }}）
          </button>
          <button
            v-if="[4, 5, 11].includes(detail.typeValue)"
            :class="{ active: detailTab === 'skip' }"
            @click="changeDetailTab('skip')">
            跳过 SKU（{{ detail.skip }}）
          </button>
        </nav>
        <table v-if="detailRows.length" :class="{ 'size-weight-table': detail.typeValue === 8 }">
          <thead>
            <tr>
              <th v-if="detail.typeValue !== 11">主图</th>
              <th>商品ID</th>
              <th v-if="detail.typeValue === 7">来源ID</th>
              <th v-if="detail.typeValue === 10">商品标题</th>
              <th v-if="detail.typeValue !== 10">
                {{ detail.typeValue === 7 ? '命中删除原因' : [6, 8, 9].includes(detail.typeValue) ? '商品标题' : ([4, 5, 11].includes(detail.typeValue) ? (detail.typeValue === 11 ? '修改类型' : 'SKU规格') : detail.typeValue === 2 ? '旧短标题' : '旧标题') }}
              </th>
              <th v-if="detail.typeValue === 10">旧货号</th>
              <th v-if="detail.typeValue === 8">旧尺寸(mm)</th>
              <th v-if="detail.typeValue === 8">旧重量(kg)</th>
              <th v-if="detail.typeValue === 8">新尺寸(mm)</th>
              <th v-if="detail.typeValue === 8">新重量(kg)</th>
              <th v-if="detail.typeValue === 10">新货号</th>
              <th v-if="detail.typeValue !== 6 && detail.typeValue !== 8 && detail.typeValue !== 9 && detail.typeValue !== 10">
                {{
                  detail.typeValue === 7 ? '商品状态' : detail.typeValue === 4
                    ? '旧价格'
                    : detail.typeValue === 5
                    ? '修改前库存'
                    : detail.typeValue === 11
                    ? '旧值'
                    : detail.typeValue === 2
                    ? '新短标题'
                    : '新标题'
                }}
              </th>
              <th v-if="detail.typeValue === 6">修改详情图数量</th>
              <th v-if="detail.typeValue === 9">修改主图数量</th>
              <th v-if="[4, 5, 11].includes(detail.typeValue)">{{ detail.typeValue === 5 ? '修改后库存' : detail.typeValue === 11 ? '新值' : '新价格' }}</th>
              <th v-if="(detail.typeValue === 6 || detail.typeValue === 9) && detailTab === 'success'">操作</th>
              <th v-if="detailTab === 'fail'">失败原因</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in detailRows" :key="item.id || item.product_id">
              <td v-if="detail.typeValue !== 11">
                <img v-if="item.main_image" class="bm-records__image" :src="item.main_image" alt="" />
                <span v-else class="bm-records__image">暂无</span>
              </td>
              <td>{{ item.product_id }}</td>
              <td v-if="detail.typeValue === 7">{{ item.source_product_id || '—' }}</td>
              <td v-if="detail.typeValue === 10">{{ item.product_title || '—' }}</td>
              <td v-if="detail.typeValue !== 10">
                {{
                  detail.typeValue === 7 ? item.match_reason : ( [6, 8, 9].includes(detail.typeValue))
                    ? item.product_title
                    : [4, 5].includes(detail.typeValue)
                    ? item.sku_spec_text || '默认规格'
                    : detail.typeValue === 11
                    ? (item.modify_type === 'spec_name' ? '规格名称' : item.modify_type === 'remark' ? '备注' : '—')
                    : detail.typeValue === 2
                    ? item.old_short_title
                    : item.old_title
                }}
              </td>
              <td v-if="detail.typeValue === 10">
                {{ item.old_huohao || '—' }}
              </td>
              <td v-if="detail.typeValue === 8">
                {{ formatOldSize(item) }}
              </td>
              <td v-if="detail.typeValue === 8">
                {{ item.old_weight ? parseFloat(item.old_weight) : '—' }}
              </td>
              <td v-if="detail.typeValue === 8">
                {{ formatNewSize(item) }}
              </td>
              <td v-if="detail.typeValue === 8">
                {{ item.new_weight ? parseFloat(item.new_weight) : '—' }}
              </td>
              <td v-if="detail.typeValue === 10">
                {{ item.new_huohao || '—' }}
              </td>
              <td v-if="detail.typeValue !== 6 && detail.typeValue !== 8 && detail.typeValue !== 9 && detail.typeValue !== 10">
                {{
                  detail.typeValue === 7 ? (item.status === 1 ? '已删除' : (item.status === 2 ? '已跳过' : '失败')) : detail.typeValue === 4
                    ? item.old_price
                    : detail.typeValue === 5
                    ? item.old_stock
                    : detail.typeValue === 11
                    ? (item.old_value || '').replace(/\|\|\|/g, ', ')
                    : detail.typeValue === 2
                    ? item.new_short_title
                    : item.new_title
                }}
              </td>
              <td v-if="detail.typeValue === 6">
                {{ getModifiedImagesCount(item) }}
              </td>
              <td v-if="detail.typeValue === 9">
                {{ getMainImagesCount(item) }}
              </td>
              <td v-if="[4, 5, 11].includes(detail.typeValue)">
                {{ detail.typeValue === 5 ? item.new_stock : detail.typeValue === 11 ? (item.new_value || '').replace(/\|\|\|/g, ', ') : item.new_price }}
              </td>
              <td v-if="detail.typeValue === 6 && detailTab === 'success'" style="min-width: 100px;">
                <button class="btn-view-images" @click="openImageDetailDialog(item)">查看</button>
              </td>
              <td v-if="detail.typeValue === 9 && detailTab === 'success'" style="min-width: 100px;">
                <button class="btn-view-images" @click="openMainImageDetailDialog(item)">查看</button>
              </td>
              <td v-if="detailTab === 'fail'" class="danger">{{ item.error_msg || '—' }}</td>
            </tr>
          </tbody>
        </table>
        <div v-else-if="!detailLoading" class="bm-records__empty">暂无数据</div>
        <footer>
          <span v-if="detailPage.total">共 {{ detailPage.total }} 条</span>
          <span v-if="detailPage.total" class="bm-records__detail-pagination">
            <button :disabled="detailPage.page <= 1 || detailLoading" @click="loadDetailPage(detailPage.page - 1)">
              上一页
            </button>
            <b>{{ detailPage.page }} / {{ detailTotalPages }}</b>
            <button
              :disabled="detailPage.page >= detailTotalPages || detailLoading"
              @click="loadDetailPage(detailPage.page + 1)">
              下一页
            </button>
            <select v-model.number="detailPage.limit" @change="changeDetailLimit">
              <option :value="10">10条/页</option>
              <option :value="20">20条/页</option>
              <option :value="50">50条/页</option>
            </select>
          </span>
          <button @click="detail = null">关闭</button>
        </footer>
      </div>
    </div>
    <div v-if="imageDetailDialog.visible" class="bm-records__mask">
      <div class="bm-records__image-modal">
        <header>
          <strong>{{ imageDetailDialog.isMainImage ? '主图修改详情' : '详情图修改详情' }}</strong>
          <button @click="imageDetailDialog.visible = false">×</button>
        </header>
        <div class="image-detail-info">
          <p><strong>商品ID：</strong>{{ imageDetailDialog.item.product_id }}</p>
          <p><strong>商品标题：</strong>{{ imageDetailDialog.item.product_title }}</p>
        </div>
        <div class="image-detail-content">
          <div
            v-for="(img, idx) in imageDetailDialog.images"
            :key="idx"
            class="image-detail-item"
            :class="{
              'image-added': img.status === 4,
              'image-replaced': img.status === 2,
              'image-moved': img.status === 5,
              'image-deleted': img.status === 3,
            }"
          >
            <el-image
              :src="img.url"
              fit="cover"
              style="width: 100%; height: 100%"
            >
              <div slot="placeholder" class="image-loading">
                <i class="el-icon-loading"></i>
              </div>
            </el-image>
            <div v-if="img.status === 4" class="change-badge badge-added">新增</div>
            <div v-if="img.status === 2" class="change-badge badge-replaced">替换</div>
            <div v-if="img.status === 5" class="change-badge badge-moved">移动</div>
            <div v-if="img.status === 3" class="change-badge badge-deleted">已删除</div>
            <div v-if="img.status === 3" class="deleted-overlay"></div>
          </div>
        </div>
        <footer>
          <button @click="imageDetailDialog.visible = false">关闭</button>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import { getCloudBatchList, getCloudBatchDetail, restoreCloudBatch } from '@/api/main/cloudBatchEdit'
// const tags = [
//   '全部',
//   '标题',
//   '导购短标题',
//   '品牌',
//   '商品属性',
//   '跨类目属性',
//   '面料材质',
//   '货号',
//   '删除商品',
//   '下架/删除低效品',
//   '上下架',
//   '定时上下架',
//   '创建渠道品',
//   '限时限量购',
//   '食品安全/营养成分表',
//   '价格(SKU)',
//   '库存',
//   'SKU编码',
//   'SKU规格名称/备注',
//   '添加SKU',
//   '删除SKU',
//   '发货模式(SKU时效)',
//   '预售时间',
//   '商品详情图',
//   '主图',
//   '主图3:4',
//   '库存计件',
//   '尺码表',
//   '区域库存开关',
//   'SKU状态',
//   'SKU规格图',
//   'SKU图',
//   '替换商品图片',
//   '统一设置SKU',
//   '白底图',
//   '导入修改(多字段)',
//   'SKU条形码（国补码）',
//   '引用SKU模板',
//   '多地址退货策略',
//   '精选联盟策略',
//   '主图视频',
//   '运费模板',
//   '商品限购',
//   '服务资质',
//   '7天无理由退换货',
//   '大件商品',
//   '三包服务承诺',
//   '虚拟商品',
//   '安装模式',
//   '综合修改(多字段修改)',
//   '价格-库存-SKU编码'
// ]
const statusMap = { 1: '等待', 2: '处理中', 3: '失败', 4: '已完成' }
const statusClassMap = { 1: 'status-waiting', 2: 'status-processing', 3: 'status-failed', 4: 'status-completed' }
export default {
  name: 'BatchModifyRecords',
  data() {
    return {
      tags: ['全部', '标题', '短标题', '货号', '价格(SKU)', '库存', 'SKU规格名称/备注', '主图', '商品详情图', '删除商品', '尺寸与重量'],
      records: [],
      activeTag: '全部',
      recordPage: { page: 1, limit: 10, total: 0 },
      jumpPage: 1,
      detail: null,
      detailTab: 'success',
      detailRows: [],
      detailLoading: false,
      detailPage: { page: 1, limit: 20, total: 0 },
      restoringId: null,
      imageDetailDialog: {
        visible: false,
        item: null,
        images: [],
        isMainImage: false
      }
    }
  },
  computed: {
    recordTotalPages() {
      const limit = Math.max(1, Number(this.recordPage.limit) || 1)
      return Math.max(1, Math.ceil((Number(this.recordPage.total) || 0) / limit))
    },
    visibleRecordPages() {
      const totalPages = this.recordTotalPages
      const currentPage = Math.min(Math.max(1, Number(this.recordPage.page) || 1), totalPages)
      const windowSize = Math.min(5, totalPages)
      let start = Math.max(1, currentPage - Math.floor(windowSize / 2))
      start = Math.min(start, totalPages - windowSize + 1)
      return Array.from({ length: windowSize }, (_, index) => start + index)
    },
    detailTotalPages() {
      return Math.max(1, Math.ceil(this.detailPage.total / this.detailPage.limit))
    }
  },
  created() {
    this.load()
  },
  methods: {
    changeTag(tag) {
      if (this.activeTag === tag) return
      this.activeTag = tag
      this.recordPage.page = 1
      this.load(1)
    },
    async load(page = this.recordPage.page) {
      try {
        const params = { page, limit: this.recordPage.limit }
        if (this.activeTag === '标题') params.type = 1
        if (this.activeTag === '短标题') params.type = 2
        if (this.activeTag === '货号') params.type = 10
        if (this.activeTag === '价格(SKU)') params.type = 4
        if (this.activeTag === '库存') params.type = 5
        if (this.activeTag === 'SKU规格名称/备注') params.type = 11
        if (this.activeTag === '主图') params.type = 9
        if (this.activeTag === '商品详情图') params.type = 6
        if (this.activeTag === '删除商品') params.type = 7
        if (this.activeTag === '尺寸与重量') params.type = 8
        const r = await getCloudBatchList(params)
        const payload = r && r.data && r.data.list !== undefined ? r.data : (r && r.data && r.data.data) || {}
        const list = Array.isArray(payload.list) ? payload.list : Array.isArray(payload) ? payload : []
        this.records = list.map((item) => {
          const statusValue = Number(item.status)
          const typeValue = Number(item.type)
          return {
            ...item,
            typeValue,
            typeName: item.type_name || '未知类型',
            statusValue,
            status: statusMap[statusValue] || item.status,
            statusClass: statusClassMap[statusValue] || '',
            success: item.success_count || 0,
            fail: item.fail_count || 0,
            skip: item.skip_count || 0,
            total: item.total || 0,
            progress: item.progress || 0,
            modDate: item.created_at || '',
            restoreDate: item.restored_at || ''
          }
        })
        this.recordPage = { ...this.recordPage, page, total: Number(payload.total || 0) }
        this.jumpPage = page
      } catch (e) {
        this.$message.error('记录加载失败')
      }
    },
    changeRecordLimit() {
      this.recordPage.page = 1
      this.load(1)
    },
    jumpRecordPage() {
      const page = Math.min(Math.max(1, Number(this.jumpPage) || 1), this.recordTotalPages)
      this.load(page)
    },
    async openDetail(record) {
      if (![1, 2, 4, 5, 6, 7, 8, 9, 10, 11].includes(record.typeValue) && record.typeName !== '删除商品') {
        this.$message.warning('该批量修改类型功能开发中')
        return
      }
      this.detail = record
      this.detailTab = 'success'
      this.detailPage = { ...this.detailPage, page: 1, total: 0 }
      await this.loadDetailPage(1)
    },
    async changeDetailTab(tab) {
      if (this.detailTab === tab) return
      this.detailTab = tab
      this.detailRows = []
      this.detailPage = { ...this.detailPage, page: 1, total: 0 }
      await this.loadDetailPage(1)
    },
    async loadDetailPage(page) {
      if (!this.detail) return
      this.detailLoading = true
      try {
        const r = await getCloudBatchDetail(this.detail.id, {
          page,
          limit: this.detailPage.limit,
          status: this.detailTab === 'success' ? 1 : this.detailTab === 'skip' ? 4 : 3
        })
        const payload = r && r.data && r.data.list !== undefined ? r.data : (r && r.data && r.data.data) || {}
        const rows = Array.isArray(payload.list) ? payload.list : Array.isArray(payload) ? payload : []
        this.detailRows = rows.map((item) => ({
          ...item,
          new_title:
            item.new_title !== undefined && item.new_title !== null
              ? item.new_title
              : item.newTitle !== undefined && item.newTitle !== null
              ? item.newTitle
              : item.title || ''
        }))
        this.detailPage = { ...this.detailPage, page, total: Number(payload.total || 0) }
      } catch (e) {
        this.$message.error('详情加载失败')
      } finally {
        this.detailLoading = false
      }
    },
    async changeDetailLimit() {
      this.detailPage.page = 1
      await this.loadDetailPage(1)
    },
    getDetailImagesCount(imagesJson) {
      if (!imagesJson) return 0
      try {
        const images = typeof imagesJson === 'string' ? JSON.parse(imagesJson) : imagesJson
        return Array.isArray(images) ? images.length : 0
      } catch (e) {
        return 0
      }
    },
    getModifiedImagesCount(item) {
      if (!item.new_detail_images) return 0
      try {
        const images = typeof item.new_detail_images === 'string' ? JSON.parse(item.new_detail_images) : item.new_detail_images
        return Array.isArray(images) ? images.length : 0
      } catch (e) {
        return 0
      }
    },
    openImageDetailDialog(item) {
      if (!item.new_detail_images) {
        this.$message.warning('该商品没有详情图修改记录')
        return
      }
      try {
        const images = typeof item.new_detail_images === 'string' ? JSON.parse(item.new_detail_images) : item.new_detail_images
        if (!Array.isArray(images) || images.length === 0) {
          this.$message.warning('该商品没有详情图修改记录')
          return
        }
        // 按 sort 字段排序
        const sortedImages = [...images].sort((a, b) => {
          const sortA = a.sort !== undefined ? a.sort : 999
          const sortB = b.sort !== undefined ? b.sort : 999
          return sortA - sortB
        })
        this.imageDetailDialog = {
          visible: true,
          item: item,
          images: sortedImages,
          isMainImage: false
        }
      } catch (e) {
        this.$message.error('详情图数据解析失败')
      }
    },
    openMainImageDetailDialog(item) {
      if (!item.new_main_images) {
        this.$message.warning('该商品没有主图修改记录')
        return
      }
      try {
        const images = typeof item.new_main_images === 'string' ? JSON.parse(item.new_main_images) : item.new_main_images
        if (!Array.isArray(images) || images.length === 0) {
          this.$message.warning('该商品没有主图修改记录')
          return
        }
        this.imageDetailDialog = {
          visible: true,
          item: item,
          images: images,
          isMainImage: true
        }
      } catch (e) {
        this.$message.error('主图数据解析失败')
      }
    },
    getMainImagesCount(item) {
      if (!item.new_main_images) return 0
      try {
        const images = typeof item.new_main_images === 'string' ? JSON.parse(item.new_main_images) : item.new_main_images
        return Array.isArray(images) ? images.length : 0
      } catch (e) {
        return 0
      }
    },
    getImagePreviewIndex(currentIndex) {
      // 计算点击预览时的索引，需要排除之前的已删除图片
      const images = this.imageDetailDialog.images
      let previewIndex = 0
      for (let i = 0; i < currentIndex; i++) {
        if (images[i].status !== 3) {
          previewIndex++
        }
      }
      return previewIndex
    },
    isRecordExpired(record) {
      // 判断记录创建时间是否超过10天
      if (!record.created_at && !record.modDate) return false
      try {
        const createdAt = new Date(record.created_at || record.modDate)
        const now = new Date()
        const diffTime = now - createdAt
        const diffDays = diffTime / (1000 * 60 * 60 * 24)
        return diffDays > 10
      } catch (e) {
        return false
      }
    },
    async restore(record) {
      if (![1, 2, 4, 5, 6, 7, 8, 9, 10, 11].includes(record.typeValue)) {
        this.$message.warning('该批量修改类型功能开发中')
        return
      }

      // 弹出确认框
      try {
        await this.$confirm('确定要恢复此批次的修改吗？恢复后将还原到修改前的状态。', '确认恢复', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning'
        })
      } catch (e) {
        // 用户点击了"否"或关闭弹窗
        return
      }

      this.restoringId = record.id
      try {
        const response = await restoreCloudBatch(record.id)
        if (response.code !== 200) {
          this.$message.error(response.message || '恢复失败')
          return
        }
        const restoredAt =
          response.data && (response.data.restored_at || (response.data.data && response.data.data.restored_at))
        if (restoredAt) record.restoreDate = restoredAt
        await this.load()
        this.$message.success('恢复成功')
      } catch (e) {
        const errorMsg = e.response && e.response.data && e.response.data.message
        this.$message.error(errorMsg || '恢复失败')
      } finally {
        this.restoringId = null
      }
    },
    formatOldSize(item) {
      if (!item.old_length && !item.old_width && !item.old_height) {
        return '—'
      }
      const length = item.old_length ? parseFloat(item.old_length) : '—'
      const width = item.old_width ? parseFloat(item.old_width) : '—'
      const height = item.old_height ? parseFloat(item.old_height) : '—'
      return `${length} × ${width} × ${height}`
    },
    formatNewSize(item) {
      if (!item.new_length && !item.new_width && !item.new_height) {
        return '—'
      }
      const length = item.new_length ? parseFloat(item.new_length) : '—'
      const width = item.new_width ? parseFloat(item.new_width) : '—'
      const height = item.new_height ? parseFloat(item.new_height) : '—'
      return `${length} × ${width} × ${height}`
    }
  }
}
</script>

<style scoped>
.bm-records {
  padding: 14px 20px;
  font-family: 'Noto Sans SC', sans-serif;
}

.bm-records__tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 14px;
}

.bm-records__tags button {
  height: 26px;
  padding: 0 10px;
  border: 1px solid #e0e0ec;
  border-radius: 13px;
  background: #f5f5f5;
  color: #666;
  cursor: pointer;
  font-size: 11px;
}

.bm-records__tags button.active {
  border-color: #1677ff;
  background: #1677ff;
  color: #fff;
}

.bm-records__table-wrap {
  overflow: hidden;
  border: 2px solid #e0e0ec;
  border-radius: 8px;
  background: #fff;
}

.bm-records__table-wrap > table {
  width: 100%;
  min-width: 860px;
  border-collapse: collapse;
}

.bm-records__table-wrap {
  overflow-x: auto;
}

.bm-records th {
  padding: 8px 12px;
  background: #f5f0e8;
  color: #666;
  font-size: 11px;
  font-weight: 500;
  text-align: left;
}

.bm-records td {
  padding: 12px;
  border-bottom: 1px solid #f5f5f5;
  font-size: 12px;
}

.bm-records td > small {
  display: block;
  margin-top: 3px;
  max-width: 240px;
  color: #999;
  font-size: 11px;
  line-height: 1.5;
}

.bm-records__progress {
  display: inline-block;
  width: 90px;
  height: 6px;
  overflow: hidden;
  border-radius: 3px;
  background: #f0f0f0;
}

.bm-records__progress i {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #c8443c, #e05858);
}

.bm-records td > b {
  margin-left: 6px;
  color: #c8443c;
  font: 600 10px 'JetBrains Mono', monospace;
}

.bm-records__status {
  padding: 2px 8px;
  border: 1px solid #ffd591;
  border-radius: 3px;
  background: #fff7e6;
  color: #fa8c16;
  font-size: 11px;
}

.bm-records__status.已完成 {
  border-color: #b7eb8f;
  background: #f6ffed;
  color: #52c41a;
}

.bm-records__status.失败 {
  border-color: #ffccd2;
  background: #fff5f5;
  color: #c8443c;
}

.success {
  color: #52c41a;
  font: 600 13px 'JetBrains Mono', monospace;
}

.danger {
  color: #c8443c;
}

.bm-records__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.bm-records__actions button {
  height: 22px;
  padding: 0 8px;
  border: 1px solid #e0e0ec;
  border-radius: 3px;
  background: #fff;
  color: #666;
  cursor: pointer;
  font-size: 10px;
}

.bm-records__actions .blue {
  border-color: #91caff;
  background: #e6f4ff;
  color: #1677ff;
}

.bm-records__actions .red {
  border-color: #ffccd2;
  background: #fff5f5;
  color: #c8443c;
}

.bm-records__table-wrap > footer {
  display: flex;
  justify-content: space-between;
  padding: 10px 14px;
  background: #f5f0e8;
  color: #999;
  font-size: 11px;
}

.bm-records__table-wrap input,
.bm-records__table-wrap select {
  height: 24px;
  border: 1px solid #e0e0ec;
  border-radius: 3px;
  color: #666;
  font-size: 11px;
}

.bm-records__table-wrap input {
  width: 38px;
  text-align: center;
}

.bm-records__table-wrap > footer > span:last-child {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.bm-records__table-wrap > footer button {
  min-width: 24px;
  height: 24px;
  padding: 0 6px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #fff;
  color: #666;
  cursor: pointer;
  font-size: 11px;
}

.bm-records__table-wrap > footer button.page-number.active {
  border-color: #f56c6c;
  color: #f56c6c;
}

.bm-records__table-wrap > footer .page-jump {
  width: 38px;
  padding: 0;
  text-align: center;
}

.bm-records__table-wrap > footer .page-jump-label {
  color: #999;
  font-size: 11px;
}

.bm-records__table-wrap > footer button:disabled {
  color: #c8c8c8;
  cursor: not-allowed;
}

.bm-records__mask {
  position: fixed;
  z-index: 3000;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(3px);
}

.bm-records__modal {
  width: 720px;
  max-width: 100%;
  height: 620px;
  overflow: hidden;
  border: 1px solid #e0e0ec;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.18);
}

.bm-records__modal > header {
  display: flex;
  justify-content: space-between;
  padding: 12px 18px;
  border-bottom: 1px solid #e0e0ec;
  background: #fafafa;
  font-size: 14px;
}

.bm-records__modal > header button {
  width: 24px;
  height: 24px;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  background: #fff;
  color: #666;
  cursor: pointer;
  font-size: 18px;
}

.bm-records__modal nav {
  display: flex;
  padding: 0 18px;
  border-bottom: 1px solid #e0e0ec;
}

.bm-records__modal nav button {
  padding: 10px 16px;
  border: 0;
  border-bottom: 2px solid transparent;
  background: #fff;
  color: #666;
  cursor: pointer;
  font-size: 12px;
}

.bm-records__modal nav button.active {
  border-bottom-color: #1677ff;
  color: #1677ff;
  font-weight: 500;
}

.bm-records__modal table {
  width: calc(100% - 36px);
  margin: 8px 18px;
  border-collapse: collapse;
}

.bm-records__modal tbody .title-cell {
  width: 260px;
  max-width: 260px;
  white-space: normal;
  word-break: break-all;
  line-height: 1.5;
  vertical-align: top;
}

.bm-records__modal tbody .title-cell {
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
}

.bm-records__modal > table {
  display: block;
  width: calc(100% - 36px);
  table-layout: fixed;
  max-height: 470px;
  overflow-y: auto;
}

.bm-records__modal > table th:nth-child(1),
.bm-records__modal > table td:nth-child(1) {
  width: 88px;
}
.bm-records__modal > table th:nth-child(2),
.bm-records__modal > table td:nth-child(2) {
  width: 120px;
}
.bm-records__modal > table th:nth-child(3),
.bm-records__modal > table td:nth-child(3),
.bm-records__modal > table th:nth-child(4),
.bm-records__modal > table td:nth-child(4) {
  width: 220px;
}
.bm-records__modal > table th:nth-child(5),
.bm-records__modal > table td:nth-child(5) {
  width: 180px;
}

/* 尺寸与重量详情表格样式 */
.bm-records__modal > table.size-weight-table th:nth-child(3),
.bm-records__modal > table.size-weight-table td:nth-child(3) {
  width: 160px;
}
.bm-records__modal > table.size-weight-table th:nth-child(4),
.bm-records__modal > table.size-weight-table td:nth-child(4),
.bm-records__modal > table.size-weight-table th:nth-child(6),
.bm-records__modal > table.size-weight-table td:nth-child(6) {
  width: 180px;
}
.bm-records__modal > table.size-weight-table th:nth-child(5),
.bm-records__modal > table.size-weight-table td:nth-child(5),
.bm-records__modal > table.size-weight-table th:nth-child(7),
.bm-records__modal > table.size-weight-table td:nth-child(7) {
  width: 60px;
}

.bm-records__empty {
  display: flex;
  height: 470px;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 13px;
}

.bm-records__image {
  display: inline-flex;
  width: 64px;
  height: 64px;
  align-items: center;
  justify-content: center;
  border: 1px solid #ffccd2;
  border-radius: 4px;
  background: #fff5f5;
  font-size: 18px;
}

img.bm-records__image {
  object-fit: cover;
}

.bm-records__modal > footer {
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: flex-end;
  padding: 12px 18px;
  border-top: 1px solid #e0e0ec;
}

.bm-records__detail-pagination {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  margin-right: auto;
}

.bm-records__detail-pagination button {
  height: 22px;
  padding: 0 6px;
  border: 1px solid #e0e0ec;
  border-radius: 3px;
  background: #fff;
  color: #666;
  cursor: pointer;
  font-size: 10px;
}

.bm-records__detail-pagination button:disabled {
  color: #bbb;
  cursor: not-allowed;
}

.bm-records__detail-pagination select {
  height: 22px;
  border: 1px solid #e0e0ec;
  border-radius: 3px;
  color: #666;
  font-size: 10px;
}

.bm-records__detail-pagination b,
.bm-records__modal > footer > span {
  font-size: 10px;
}

.bm-records__modal > footer button {
  height: 32px;
  padding: 0 14px;
  border: 1px solid #e0e0ec;
  border-radius: 6px;
  background: #fff;
  color: #666;
  cursor: pointer;
  font-size: 13px;
}

.bm-records__modal > footer .bm-records__detail-pagination button {
  min-width: 42px;
  height: 20px;
  padding: 0 4px;
  font-size: 10px;
}

.bm-records__detail-pagination {
  gap: 3px;
}

.btn-view-images {
  padding: 4px 12px;
  border: 1px solid #1677ff;
  border-radius: 4px;
  background: #fff;
  color: #1677ff;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-view-images:hover {
  background: #1677ff;
  color: #fff;
}

.bm-records__image-modal {
  position: relative;
  width: 90%;
  max-width: 1200px;
  max-height: 85vh;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
}

.bm-records__image-modal > header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #e0e0ec;
}

.bm-records__image-modal > header > strong {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.bm-records__image-modal > header > button {
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  color: #999;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
  transition: color 0.2s;
}

.bm-records__image-modal > header > button:hover {
  color: #333;
}

.image-detail-info {
  padding: 16px 20px;
  background: #f9f9f9;
  border-bottom: 1px solid #e0e0ec;
}

.image-detail-info p {
  margin: 4px 0;
  font-size: 13px;
  color: #666;
}

.image-detail-content {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 16px;
  align-content: start;
}

.image-detail-item {
  position: relative;
  width: 120px;
  height: 120px;
  border: 2px solid #e8e8e8;
  border-radius: 4px;
  overflow: hidden;
  flex-shrink: 0;
}

.image-detail-item.image-added {
  border: 2px solid #52c41a;
  box-shadow: 0 0 0 2px rgba(82, 196, 26, 0.1);
}

.image-detail-item.image-replaced {
  border: 2px solid #faad14;
  box-shadow: 0 0 0 2px rgba(250, 173, 20, 0.1);
}

.image-detail-item.image-moved {
  border: 2px solid #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1);
}

.image-detail-item.image-deleted {
  border: 2px solid #ff4d4f;
  box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.1);
  cursor: not-allowed;
}

.change-badge {
  position: absolute;
  top: 4px;
  right: 4px;
  padding: 2px 8px;
  font-size: 11px;
  line-height: 1.4;
  border-radius: 2px;
  color: #fff;
  font-weight: 500;
  z-index: 1;
  white-space: nowrap;
}

.badge-replaced {
  background-color: #faad14;
}

.badge-added {
  background-color: #52c41a;
}

.badge-moved {
  background-color: #1890ff;
}

.badge-deleted {
  background-color: #ff4d4f;
}

.deleted-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 0;
}

.image-deleted::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 10%;
  right: 10%;
  height: 2px;
  background-color: #ff4d4f;
  transform: translateY(-50%) rotate(-15deg);
  z-index: 1;
}

.image-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: #f5f5f5;
  color: #999;
}

.image-loading i {
  font-size: 20px;
}


.bm-records__image-modal > footer {
  display: flex;
  justify-content: flex-end;
  padding: 16px 20px;
  border-top: 1px solid #e0e0ec;
}

.bm-records__image-modal > footer > button {
  height: 32px;
  padding: 0 20px;
  border: 1px solid #e0e0ec;
  border-radius: 6px;
  background: #fff;
  color: #666;
  cursor: pointer;
  font-size: 13px;
}

.bm-records__image-modal > footer > button:hover {
  border-color: #1677ff;
  color: #1677ff;
}
</style>
<style scoped>
.bm-records__status {
  padding: 2px 8px;
  border-radius: 3px;
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
}

.bm-records__status.status-completed {
  background: rgb(246, 255, 237);
  border: 1px solid rgb(183, 235, 143);
  color: rgb(82, 196, 26);
}

.bm-records__status.status-processing,
.bm-records__status.status-waiting {
  background: rgb(255, 247, 230);
  border: 1px solid rgb(255, 213, 145);
  color: rgb(250, 140, 22);
}

.bm-records__status.status-failed {
  background: rgb(255, 245, 245);
  border: 1px solid rgb(255, 205, 210);
  color: rgb(200, 68, 60);
}
</style>
